export function avatarLetters(name) {
  if (!name) {
    return ''
  }
  const names = name.split(' ')
  const first = names[0].split('')[0]
  const last = names.length > 1 ? names[1].split('')[0] : null

  if (first || last) {
    return `${first}${last}`
  } else {
    return ''
  }
}

export function nameToFirstAndLast(name) {
  if (!name) {
    return null
  }

  const names = name.split(' ')
  const first = names[0]
  const last = names.length > 1 ? names[1] : null

  if (first || last) {
    return {
      first: first,
      last: last,
    }
  } else {
    return null
  }
}
